module.exports = __webpack_public_path__ + "static/media/ThePunisher.54b26095.jpg";